'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = entman;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _normalizr = require('normalizr');

var _reduxBatchedActions = require('redux-batched-actions');

var _selectors = require('./selectors');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// UTILS {{{
function normalizeData(schema, data) {
  var dataWithIds = (0, _utils.arrayFrom)(data).map(function (e) {
    return e.id ? e : _extends({}, e, { id: (0, _v2.default)() });
  });
  return (0, _normalizr.normalize)(dataWithIds, [schema]);
}

function extractEntities(entitiesAndKey) {
  return Object.keys(entitiesAndKey.entities).map(function (id) {
    return {
      entity: _extends({}, entitiesAndKey.entities[id], {
        id: entitiesAndKey.entities[id].id ? entitiesAndKey.entities[id].id : id
      }),
      key: entitiesAndKey.key
    };
  });
}

// We try to dispatch the actions of the orignal entities
// (the ones which schema was passed) first
function sortMainFirst(main) {
  return function (entity1, entity2) {
    if (entity1.key === main.key) {
      return -1;
    } else if (entity2.key === main.key) {
      return 1;
    }
    return 0;
  };
}

function getFromState(state, key, id) {
  return (0, _get2.default)((0, _selectors.getEntitiesSlice)(state), [key, id]);
}
// }}}


function createCreateEntityActions(action, getState) {
  var dataPath = (0, _get2.default)(action, 'meta.dataPath');
  var schema = (0, _get2.default)(action, 'meta.schema');
  var skipNormalization = (0, _get2.default)(action, 'meta.skipNormalization');
  var data = skipNormalization ? (0, _get2.default)(action, dataPath) : normalizeData(schema, (0, _get2.default)(action, dataPath));
  return Object.keys(data.entities).map(function (key) {
    return { entities: data.entities[key], key: key };
  }).reduce(function (memo, entitiesAndKey) {
    return [].concat(_toConsumableArray(memo), _toConsumableArray(extractEntities(entitiesAndKey)));
  }, []).map(function (entity) {
    return _extends({}, entity, { oldEntity: getFromState(getState(), entity.key, entity.entity.id) });
  }).sort(sortMainFirst(schema)).map(function (payload) {
    if (payload.oldEntity) {
      return {
        type: '@@entman/UPDATE_ENTITY_' + payload.key.toUpperCase(),
        payload: payload
      };
    }
    return {
      type: '@@entman/CREATE_ENTITY_' + payload.key.toUpperCase(),
      payload: payload
    };
  });
}

function createUpdateEntityActions(action, getState) {
  var dataPath = (0, _get2.default)(action, 'meta.dataPath');
  var schema = (0, _get2.default)(action, 'meta.schema');
  var ids = (0, _get2.default)(action, 'meta.ids');
  var useDefault = (0, _get2.default)(action, 'meta.useDefault');
  var data = normalizeData(schema, ids.map(function (id) {
    return _extends({}, (0, _get2.default)(action, dataPath), { id: id });
  }));
  return Object.keys(data.entities).map(function (key) {
    return { entities: data.entities[key], key: key };
  }).reduce(function (memo, entitiesAndKey) {
    return [].concat(_toConsumableArray(memo), _toConsumableArray(extractEntities(entitiesAndKey)));
  }, []).map(function (entity) {
    return _extends({}, entity, { oldEntity: getFromState(getState(), entity.key, entity.entity.id) });
  }).sort(sortMainFirst(schema)).map(function (payload) {
    if (!payload.oldEntity) {
      return {
        type: '@@entman/CREATE_ENTITY_' + payload.key.toUpperCase(),
        payload: payload
      };
    }
    return {
      type: '@@entman/UPDATE_ENTITY_' + payload.key.toUpperCase(),
      payload: _extends({}, payload, { useDefault: useDefault })
    };
  });
}

function createUpdateEntityIdActions(action, getState) {
  var schema = (0, _get2.default)(action, 'meta.schema');
  var oldId = (0, _get2.default)(action, 'meta.oldId');
  var newId = (0, _get2.default)(action, 'meta.newId');
  return [{
    type: '@@entman/UPDATE_ENTITY_ID_' + schema.key.toUpperCase(),
    payload: { oldId: oldId, newId: newId, oldEntity: getFromState(getState(), schema.key, oldId) }
  }];
}

function createDeleteEntityActions(action, getState) {
  var schema = (0, _get2.default)(action, 'meta.schema');
  var ids = (0, _get2.default)(action, 'meta.ids');
  // Do we cascade delete?
  return ids.map(function (id) {
    return { id: id, key: schema.key };
  }).map(function (info) {
    return { entity: getFromState(getState(), info.key, info.id), key: info.key };
  }).map(function (payload) {
    return {
      type: '@@entman/DELETE_ENTITY_' + schema.key.toUpperCase(),
      payload: payload
    };
  });
}

function processEntmanAction(store, next, action, enableBatching) {
  switch (action.meta.type) {
    case 'CREATE_ENTITIES':
      {
        if (enableBatching) {
          return next((0, _reduxBatchedActions.batchActions)(createCreateEntityActions(action, store.getState)));
        }
        return createCreateEntityActions(action, store.getState).forEach(next);
      }
    case 'UPDATE_ENTITIES':
      {
        if (enableBatching) {
          return next((0, _reduxBatchedActions.batchActions)(createUpdateEntityActions(action, store.getState)));
        }
        return createUpdateEntityActions(action, store.getState).forEach(next);
      }
    case 'UPDATE_ENTITY_ID':
      {
        if (enableBatching) {
          return next((0, _reduxBatchedActions.batchActions)(createUpdateEntityIdActions(action, store.getState)));
        }
        return createUpdateEntityIdActions(action, store.getState).forEach(next);
      }
    case 'DELETE_ENTITIES':
      {
        if (enableBatching) {
          return next((0, _reduxBatchedActions.batchActions)(createDeleteEntityActions(action, store.getState)));
        }
        return createDeleteEntityActions(action, store.getState).forEach(next);
      }
    default:
      {
        console.warn('[ENTMAN] Unknown action type found ' + action.meta.type);
        return next(action);
      }
  }
}

function entman() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var enableBatching = config.enableBatching;

  return function (store) {
    return function (next) {
      return function (action) {
        if (!(0, _get2.default)(action, 'meta.isEntmanAction', false)) {
          return next(action);
        }
        next(action);
        return processEntmanAction(store, next, action, enableBatching);
      };
    };
  };
}